"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

var _modalList = /*#__PURE__*/new WeakMap();

let ModalManagerInstance = /*#__PURE__*/function () {
  function ModalManagerInstance() {
    _classCallCheck(this, ModalManagerInstance);

    _modalList.set(this, {
      writable: true,
      value: []
    });

    _defineProperty(this, "addModal", modal => {
      _classPrivateFieldGet(this, _modalList).push(modal);
    });
  }

  _createClass(ModalManagerInstance, [{
    key: "isTopmost",
    value: function isTopmost(modal) {
      if (!modal || !_classPrivateFieldGet(this, _modalList).length) {
        return false;
      }

      return _classPrivateFieldGet(this, _modalList).indexOf(modal) === _classPrivateFieldGet(this, _modalList).length - 1;
    }
  }, {
    key: "removeModal",
    value: function removeModal(modal) {
      const modalIndex = _classPrivateFieldGet(this, _modalList).indexOf(modal);

      if (modalIndex === -1) {
        return;
      }

      _classPrivateFieldGet(this, _modalList).splice(modalIndex, 1);
    }
  }, {
    key: "clearList",
    value: function clearList() {
      _classPrivateFieldSet(this, _modalList, []);
    }
  }]);

  return ModalManagerInstance;
}();

const ModalManager = new ModalManagerInstance();
var _default = ModalManager;
exports.default = _default;